import { render, staticRenderFns } from "./DecisionDiamondRule.vue?vue&type=template&id=069b74f0&scoped=true"
import script from "./DecisionDiamondRule.vue?vue&type=script&lang=js"
export * from "./DecisionDiamondRule.vue?vue&type=script&lang=js"
import style0 from "./DecisionDiamondRule.vue?vue&type=style&index=0&id=069b74f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "069b74f0",
  null
  
)

export default component.exports